import { t } from "i18next";

// dashboard
export const TABS_DASHBOARD = [
  { label: "Riepilogo Attività", tab: "Attività", disabled: false },

  /*   {

    label: "Altri Servizi",
    tab: "Servizi",
    disabled: true,
  }, */
];
// Valida Documenti
export const TABS_VALIDA_DOC = [
  { label: "Documenti in Validazione", tab: "Validazione" },
  { label: "Magic View (In arrivo)", tab: "Magic" },
];

// news

export const TABS_NEWS = [
  { label: "Tutte", tab: "Tutte" },
  { label: "Attualità", tab: "a3187ce1-8d36-11ee-a282-0245bc6eeaae" },
  { label: "Fisco", tab: "b121c3d7-8d36-11ee-a282-0245bc6eeaae" },
  { label: "Previdenza", tab: "b8753e6d-8d36-11ee-a282-0245bc6eeaae" },
  { label: "Eventi", tab: "c544d949-8d36-11ee-a282-0245bc6eeaae" },
];

export const TABS_SERVICES = () => [
  {
    label: (
      <div className="flex gap-1 items-center">
        {t("Services")}
      </div>
    ),
    tab: "services",
  },
  {
    label: (
      <div className="flex gap-1 items-center">
        {t("OtherServices")}
      </div>
    ),
    tab: "otherservices",
  },
]
